import { j as o } from "./kezios-design-system.esm172.js";
import { Box as s } from "@mantine/core";
import t from "./kezios-design-system.esm176.js";
const x = ({ size: r, className: l, onClick: e }) => /* @__PURE__ */ o.jsx(s, { children: /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: r,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${t.root} ${l}`,
    onClick: e,
    children: /* @__PURE__ */ o.jsx("g", { filter: "url(#blurry)", children: /* @__PURE__ */ o.jsx(
      "path",
      {
        className: t.playButton,
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96ZM40.5 65.6066L67.5 50.5152C69.5 49.3973 69.5 46.6027 67.5 45.4848L40.5 30.3934C38.5 29.2756 36 30.6729 36 32.9087V63.0913C36 65.3271 38.5 66.7244 40.5 65.6066Z"
      }
    ) })
  }
) });
export {
  x as PlayButton
};
